import React from "react";
import { Autocomplete, TextField, MenuItem } from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import CheckIcon from "@mui/icons-material/Check";

const ACCENT = "#63c9dc";
const TEXT = "#280137";
const BORDER = "rgba(65, 60, 88, 0.12)";
const BORDER_HOVER = "rgba(99, 201, 220, 0.32)";
const BORDER_FOCUS = "rgba(99, 201, 220, 0.42)";
const PLACEHOLDER = "rgba(109, 95, 131, 0.76)";
const OPTION_HOVER = "rgba(99, 201, 220, 0.1)";
const OPTION_SELECTED = "rgba(99, 201, 220, 0.16)";
const CHIP_BG = "rgba(99, 201, 220, 0.14)";

export const MultiSelectDropdown = ({
    id,
    value,
    onChange,
    options,
    placeholder,
    className,
    onFocus,
}) => {
    return (
        <Autocomplete
            onFocus={onFocus}
            className={className}
            multiple
            sx={{
                backgroundColor: "#ffffff",
                color: TEXT,
                height: 'auto',
                padding: '.1rem .25rem .3rem .25rem !important',
                paddingBottom: '.3rem',
                width: '100%',
                borderRadius: "14px",
            }}
            id={id}
            value={value}
            onChange={(event, newValue) => onChange(newValue)}
            popupIcon={<KeyboardArrowDownOutlinedIcon />}
            options={options}
            getOptionLabel={(option) => option}
            disableCloseOnSelect
            componentsProps={{
                paper: {
                    sx: {
                        backgroundColor: "#ffffff",
                        color: TEXT,
                        border: `1px solid ${BORDER}`,
                        boxShadow: "0 18px 36px rgba(19, 11, 34, 0.12)",
                        borderRadius: "14px",
                    },
                },
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={placeholder}
                    size="small"
                    sx={{
                        backgroundColor: "#ffffff",
                        minHeight: 40,
                        width: "100%",
                        borderRadius: "14px",

                        "& .MuiInputBase-input": {
                            color: `${TEXT} !important`,
                        },
                        "& .MuiInputBase-input::placeholder": {
                            color: `${PLACEHOLDER} !important`,
                            opacity: 1,
                        },

                        "& .MuiOutlinedInput-root": {
                            color: TEXT,
                            "& .MuiChip-root": {
                                backgroundColor: CHIP_BG,
                                color: TEXT,
                                fontSize: "1rem",
                                height: "28px",
                                "& .MuiChip-label": {
                                    color: TEXT,
                                    fontSize: "1rem",
                                },
                                "& .MuiChip-deleteIcon": {
                                    color: "#6d5f83",
                                    "&:hover": {
                                        color: TEXT,
                                    },
                                },
                            },

                            "& fieldset": {
                                borderColor: BORDER,
                            },
                            "&:hover fieldset": {
                                borderColor: BORDER_HOVER,
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: BORDER_FOCUS,
                            },
                        },
                    }}
                />
            )}
            renderOption={(props, option, { selected }) => (
                <MenuItem
                    {...props}
                    key={option}
                    value={option}
                    sx={{
                        backgroundColor: selected ? OPTION_SELECTED : "#ffffff",
                        color: `${TEXT} !important`,
                        fontSize: "0.75rem",
                        justifyContent: "space-between",
                        "&:hover": {
                            backgroundColor: OPTION_HOVER,
                            color: `${TEXT} !important`,
                        },
                        "&.Mui-focused": {
                            backgroundColor: OPTION_HOVER,
                            color: `${TEXT} !important`,
                        },
                        "&.Mui-selected": {
                            backgroundColor: OPTION_SELECTED,
                            color: `${TEXT} !important`,
                        },
                        "&.Mui-disabled": {
                            color: "#a99cb8",
                        },
                    }}
                >
                    {option}
                    {selected ? <CheckIcon sx={{ color: ACCENT }} /> : null}
                </MenuItem>
            )}
        />
    );
};
